import type { TowerDesign } from "@/game/towerSpec";
/** EXACT: 104ft self-support (American Tower), 118 mph, Exposure A. Face taper estimated base ~10ft/top ~3.5ft (drawing not text-extractable). */
export const design: TowerDesign = {
  id: "selfsupport-glastonbury-104ft",
  name: "Self-Support (Glastonbury 104 ft)",
  description: "Real 104 ft self-support tower, Glastonbury CT (American Tower, 118 mph).",
  author: "reference: 02_engineering_drawings",
  spec: {
    type: "lattice",
    height: 31.70,
    stack: { faces: 3, panels: 10, baseRadius: 1.76, topRadius: 0.62,
      legSection: "legHeavy", braceSection: "braceMed", legMaterial: "a572", braceMaterial: "a36", bracing: "X" },
    foundation: { soil: "dense-sand", base: { type: "pad", width: 2.5, diameter: 1, depth: 2.5, concrete: "c30" },
      connection: { kind: "anchorBolts", nBolts: 8, bolt: "b1_5", grade: "f1554_55", boltCircleDia: 0.7, embedment: 0.8, edgeDistance: 0.35, platePlanArea: 0.5, plateThickness: 0.045, plateGrade: "a36rod", fc: 30e6 } },
  },
};
